module.exports = __webpack_public_path__ + "static/img/day-cream-01.1799242.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/day-cream-01.jpg
// module id = 257
// module chunks = 1